<template>
  <div class="intermediate_wrap">
    <div class="taxation_title">
      <h2>智能财税中级</h2>
    </div>
    <ul v-if="productFlag == 3" class="taxation_item">
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:ctx')">
        <img src="../img/ctx-logo.png" alt="" class="app_logo" />
        <img src="../img/ctx-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('ctx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:ptx')">
        <img src="../img/ptx-logo.png" alt="" class="app_logo" />
        <img src="../img/ptx-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('ptx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:jss')">
        <img src="../img/jss-logo.png" alt="" class="app_logo" />
        <img src="../img/jss-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('jss')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcsT:zwfz')">
        <img src="../img/zwfz-logo.png" alt="" class="app_logo" />
        <img src="../img/zwfz-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('zwfz')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcs:gxl')">
        <img src="../img/gxl-logo.png" alt="" class="app_logo" />
        <img src="../img/ctx-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySys('gxl')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zhsxappcs:sl')">
        <img src="../img/sl-logo.png" alt="" class="app_logo" />
        <img src="../img/zwfz-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySl('sl')">进入系统</el-button>
      </li>
    </ul>
    <ul v-if="productFlag == 4" class="taxation_item">
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcsT:ctx')">
        <img src="../img/ctx-logo.png" alt="" class="app_logo" />
        <img src="../img/ctx-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('ctx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcsT:ptx')">
        <img src="../img/ptx-logo.png" alt="" class="app_logo" />
        <img src="../img/ptx-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('ptx')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcsT:jss')">
        <img src="../img/jss-logo.png" alt="" class="app_logo" />
        <img src="../img/jss-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('jss')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcsT:zwfz')">
        <img src="../img/zwfz-logo.png" alt="" class="app_logo" />
        <img src="../img/zwfz-bg.png" alt="" class="app_bg" />
        <span class="text">（中级）</span>
        <el-button @click="entrySys('zwfz')">进入系统</el-button>
      </li>
      <li v-if="isStudent || $_has('zledu.gxzx.zsrwappcs:gxl')">
        <img src="../img/gxl-logo.png" alt="" class="app_logo" />
        <img src="../img/ctx-bg.png" alt="" class="app_bg" />
        <el-button @click="entrySys('gxl')">进入系统</el-button>
      </li>
    </ul>
    <el-dialog :visible.sync="centerDialogVisible" width="400px" center>
      <div class="cont">
        <p>请选择您要进入的案例公司：</p>
        <ul>
          <li
            :class="{ active: index === curId }"
            v-for="(item, index) in companyList"
            :key="index"
            @click="tabClick(item, index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import crypto from "crypto";
import * as userApi from "../../../../api/userApi";
export default {
  data() {
    return {
      sysUserPermissionList:
        JSON.parse(localStorage.getItem("sysUserPermissionList")) || [], // 权限对象
      userType: sessionStorage.getItem("userType"), //用户身份
      isStudent: false,
      productFlag: sessionStorage.getItem("productFlag"),
      centerDialogVisible: false,
      companyList: [
        { name: "北京神龙贸易有限公司", code: "BJ009312", tcode: "001" },
        { name: "北京星晨办公用品有限公司", code: "BJ009319", tcode: "002" },
        { name: "杭州康健医疗器械有限公司", code: "BJ009321", tcode: "003" },
        { name: "北京乐嘉食品有限责任公司", code: "BJ013145", tcode: "004" },
      ],
      curId: null,
      sys: "",
	    deptId: sessionStorage.getItem('deptId'),
	  userName: sessionStorage.getItem('userName'),
	  stxUrl: process.env.STX_API,
    };
  },
  created() {
    if (this.userType == 2 || this.userType == 3) {
      this.isStudent = true;
    } else {
      this.isStudent = false;
    }

    // 临时使用，王东东  。机构为 中联学院A (deptId == 11) ，账号存在有SX2021的用户使用
    if (this.deptId == 11 && this.userName.includes("SX2021")) {
      this.stxUrl = process.env.STX_LS_API;
    } else {
      this.stxUrl = process.env.STX_API;
    }
  },
  methods: {
    setSha1(url, secretKey) {
      // 加密
      let hmac = crypto.createHmac("sha1", secretKey || "123456");
      hmac.update(url);
      return hmac.digest("hex");
    },
    entrySys(sys) {
      // this.courseType  1 1+X平台、2 单项训练 3综合平台
      // this.productId   1 综合 2 单项
      // this.type        1、2 单项 3 综合
      // 状态判断
      // let status = false;
      // if (sys=='zwfz' || this.userType == 0){
      //   status = true;
      // }else{
      //   if (this.sysUserPermissionList && this.sysUserPermissionList.length){
      //     [].forEach.call(this.sysUserPermissionList, item =>{
      //         if (item.productId == 1) {
      //           if (this.userType == 1){
      //             if (item.teacherOnoff == true) {
      //               status = true;
      //             }
      //           }
      //           if (this.userType == 2){
      //             if (item.studentOnoff == true) {
      //               status = true;
      //             }
      //           }
      //         }
      //     })
      //   }else{
      //     status = false;
      //   }
      // }
      // if (!status) {
      //   this.$messageWarning("没有开通权限");
      //   return false;
      // }
      if (localStorage.getItem("Authorization")) {
        let param = {
          productCode: "ctx",
          productLevel: 2,
        };
        userApi.intoSysJudge(param).then((res) => {
          if (res.code == 0) {
            this.sys = sys;
            if (
              res.data.length < this.companyList.length &&
              (sys == "ctx" || sys == "ptx" || sys == "jss" || sys == "gxl")
            ) {
              this.centerDialogVisible = true;
              this.curId = null;
            } else {
              userApi
                .isExpired(localStorage.getItem("Authorization"))
                .then((rs) => {
                  if (rs.code == 0 && rs.data == 0) {
                    if (
                      sys == "ctx" ||
                      sys == "ptx" ||
                      sys == "jss" ||
                      sys == "gxl"
                    ) {
                      let userType = this.userType;
                      // let deptIdArr = ['129','134','13','516','653','648']
                      // if((userType==2||userType==3) && !deptIdArr.includes(sessionStorage.getItem('deptId'))){
                      //   this.$messageWarning('暂未开放')
                      //   this.loading = false
                      //   return
                      // }
                      // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
                      //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
                      //   this.loading = false
                      //   return
                      // }
                      var tmpWin = window.open();
                      tmpWin.document.open();
                      tmpWin.document.write("跳转中，请稍后。。。");
                      tmpWin.document.close();
                      let phone = sessionStorage.getItem("mobile");
                      let name = sessionStorage.getItem("loginName");
                      let schoolId = sessionStorage.getItem("deptId");
                      let schoolName = sessionStorage.getItem("deptName");
                      let time = new Date().getTime() + "";
                      let userId = sessionStorage.getItem("userId");
                      let classId = "";
                      let courseId = "";
                      classId = sessionStorage.getItem("userId") + "8888";
                      courseId = sessionStorage.getItem("deptId") + "8888";

                      let url =
                        "classId=" +
                        classId +
                        "&className=智能财税中级师资研修班&courseId=" +
                        courseId +
                        "&mobile=" +
                        phone +
                        "&nickName=" +
                        name +
                        "&platform=" +
                        sys +
                        "&questionId=999998888&schoolId=" +
                        schoolId +
                        "&schoolName=" +
                        schoolName +
                        "&time=" +
                        time +
                        "&userId=" +
                        userId +
                        "&userType=" +
                        userType;
                      let sha1sign = this.setSha1(url);
                      let templates = "";
                      if (process.env.hostStr == "zledusx") {
                        templates = "BJ009312,BJ009319,BJ009321,BJ013145";
                      } else {
                        templates = "001,002,003,004,005";
                      }
                      let stxObj = {
                        courseId: courseId,
                        classId: classId,
                        className: "智能财税中级师资研修班",
                        mobile: phone,
                        nickName: name,
                        platform: sys,
                        questionId: "999998888",
                        schoolId: schoolId,
                        schoolName: schoolName,
                        templates: templates,
                        time: time,
                        userId: userId,
                        userType: this.userType,
                        sign: sha1sign,
                      };
                      axios
                        .post(this.stxUrl, qs.stringify(stxObj))
                        .then((res) => {
                          if (res.data.result) {
                            tmpWin.location = res.data.value;
                            this.loading = false;
                          } else {
                            this.$messageError(res.data.error.message);
                            tmpWin.document.open();
                            tmpWin.document.write(res.data.error.message);
                            tmpWin.document.close();
                            this.loading = false;
                          }
                        })
                        .catch((err) => {
                          tmpWin.document.open();
                          if (err.code == "401") {
                            tmpWin.document.write("登录已过期，请重新登录");
                            tmpWin.location.href = process.env.BASE_API;
                          } else {
                            tmpWin.document.write("接口访问异常" + err.code);
                          }
                          tmpWin.document.close();
                          this.loading = false;
                        });
                    } else if (sys == "zwfz") {
                      let href =
                        process.env.DUMMY_API +
                        "/#/patentApply?token=" +
                        localStorage.getItem("Authorization") +
                        "&questionId=999998888&courseId=99999999&classId=999998888&type=1&degree=intermediate&userName=" +
                        sessionStorage.getItem("loginName") +
                        "&shwoMenu=true";
                      window.open(href, "_blank");
                      this.loading = false;
                    } else {
                      this.loading = false;
                      this.$messageWarning("暂无权限，请联系管理员！");
                    }
                  } else {
                    this.$router.push({ path: "/home" });
                    this.$messageError("登录已过期，请重新登录");
                    localStorage.removeItem("Authorization");
                    localStorage.removeItem("isbinding");
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        });
      } else {
        this.loading = false;
        this.$router.push({ path: "/home" });
      }
    },
    tabClick(item, i) {
      this.curId = i;
      let code = "";
      if (process.env.hostStr == "zledusx") {
        code = item.code;
      } else {
        code = item.tcode;
      }
      let param = {
        productCode: "ctx",
        productLevel: 2,
        templateCode: code,
      };
      userApi.selectSysJudge(param).then((res) => {
        console.log(res);
        if (res.code == 0) {
          userApi
            .isExpired(localStorage.getItem("Authorization"))
            .then((rs) => {
              if (rs.code == 0 && rs.data == 0) {
                if (
                  this.sys == "ctx" ||
                  this.sys == "ptx" ||
                  this.sys == "jss" ||
                  this.sys == "gxl"
                ) {
                  let userType = this.userType;
                  // let deptIdArr = ['129','134','13','516','653','648']
                  // if((userType==2||userType==3) && !deptIdArr.includes(sessionStorage.getItem('deptId'))){
                  //   this.$messageWarning('暂未开放')
                  //   this.loading = false
                  //   return
                  // }
                  // if((sessionStorage.getItem('auditStatus')!=2) && userType==1 ){
                  //   this.$messageWarning('没有访问权限，请联系学校管理员提交账号审核。')
                  //   this.loading = false
                  //   return
                  // }
                  var tmpWin = window.open();
                  tmpWin.document.open();
                  tmpWin.document.write("跳转中，请稍后。。。");
                  tmpWin.document.close();
                  let phone = sessionStorage.getItem("mobile");
                  let name = sessionStorage.getItem("loginName");
                  let schoolId = sessionStorage.getItem("deptId");
                  let schoolName = sessionStorage.getItem("deptName");
                  let time = new Date().getTime() + "";
                  let userId = sessionStorage.getItem("userId");
                  let classId = "";
                  let courseId = "";
                  classId = sessionStorage.getItem("userId") + "8888";
                  courseId = sessionStorage.getItem("deptId") + "8888";

                  let url =
                    "classId=" +
                    classId +
                    "&className=智能财税中级师资研修班&courseId=" +
                    courseId +
                    "&mobile=" +
                    phone +
                    "&nickName=" +
                    name +
                    "&platform=" +
                    this.sys +
                    "&questionId=999998888&schoolId=" +
                    schoolId +
                    "&schoolName=" +
                    schoolName +
                    "&time=" +
                    time +
                    "&userId=" +
                    userId +
                    "&userType=" +
                    userType;
                  let sha1sign = this.setSha1(url);
                  let templates = code;
                  // if(process.env.hostStr=='zledusx'){
                  //   templates = "BJ009312,BJ009319,BJ009321,BJ013145"
                  // }else{
                  //   templates = "001,002,003,004,005"
                  // }
                  let stxObj = {
                    courseId: courseId,
                    classId: classId,
                    className: "智能财税中级师资研修班",
                    mobile: phone,
                    nickName: name,
                    platform: this.sys,
                    questionId: "999998888",
                    schoolId: schoolId,
                    schoolName: schoolName,
                    templates: templates,
                    time: time,
                    userId: userId,
                    userType: this.userType,
                    sign: sha1sign,
                  };
                  axios
                    .post(this.stxUrl, qs.stringify(stxObj))
                    .then((res) => {
                      if (res.data.result) {
                        tmpWin.location = res.data.value;
                        this.loading = false;
                      } else {
                        this.$messageError(res.data.error.message);
                        tmpWin.document.open();
                        tmpWin.document.write(res.data.error.message);
                        tmpWin.document.close();
                        this.loading = false;
                      }
                    })
                    .catch((err) => {
                      tmpWin.document.open();
                      if (err.code == "401") {
                        tmpWin.document.write("登录已过期，请重新登录");
                        tmpWin.location.href = process.env.BASE_API;
                      } else {
                        tmpWin.document.write("接口访问异常" + err.code);
                      }
                      tmpWin.document.close();
                      this.loading = false;
                    });
                } else if (this.sys == "zwfz") {
                  let href =
                    process.env.DUMMY_API +
                    "/#/patentApply?token=" +
                    localStorage.getItem("Authorization") +
                    "&questionId=999998888&courseId=99999999&classId=999998888&type=1&degree=intermediate&userName=" +
                    sessionStorage.getItem("loginName");
                  window.open(href, "_blank");
                  this.loading = false;
                } else {
                  this.loading = false;
                  this.$messageWarning("暂无权限，请联系管理员！");
                }
              } else {
                this.$router.push({ path: "/home" });
                this.$messageError("登录已过期，请重新登录");
                localStorage.removeItem("Authorization");
                localStorage.removeItem("isbinding");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    entrySl(sys) {
      let that = this;
      if (localStorage.getItem("Authorization")) {
        userApi
          .isExpired(localStorage.getItem("Authorization"))
          .then((rs) => {
            if (rs.code == 0 && rs.data == 0) {
              let jumpObj = that.getJumpInfo(sys);
              if (sys == "sl") {
                that.zljtLogin(sys).then((rs) => {
                  if (rs.data.code == 0) {
                    let host = process.env.XSL_API;
                    let slParams = `qstId=${jumpObj.qstId}&token=${rs.data.data.access_token}&nickname=${name}`;
                    let src = `${host}?${slParams}`;
                    window.open(src);
                  } else {
                    that.$messageError(rs.data.msg);
                  }
                });
              } else {
                this.loading = false;
                this.$messageWarning("暂无权限，请联系管理员！");
              }
            } else {
              this.$router.push({ path: "/home" });
              this.$messageError("登录已过期，请重新登录");
              localStorage.removeItem("Authorization");
              localStorage.removeItem("isbinding");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.loading = false;
        this.$router.push({ path: "/home" });
      }
    },
    async zljtLogin(type) {
      // 中联集团登录
      let jumpObj = this.getJumpInfo(type);
      // 加密参数
      let shanStr = `{clientId=${jumpObj.clientId}, encrypted=${jumpObj.encrypted}, identity=${jumpObj.identity}, item=${jumpObj.item}, qstId=${jumpObj.qstId}, roleCode=${jumpObj.roleCodes}, templateCode=${jumpObj.templateCode}, timeStamp=${jumpObj.timestamp}, token=${jumpObj.token}, userType=${jumpObj.userType}, username=${jumpObj.username}}`;
      let secretKey = this.setSha1(shanStr, "02424D4FD04A007E453DADA28E4EEE37");
      let params = {
        clientId: jumpObj.clientId,
        encrypted: jumpObj.encrypted,
        identity: jumpObj.identity,
        item: jumpObj.item,
        qstId: jumpObj.qstId,
        roleCode: jumpObj.roleCodes,
        sign: secretKey,
        templateCode: jumpObj.templateCode,
        timeStamp: jumpObj.timestamp,
        token: jumpObj.token,
        userId: jumpObj.userId,
        userType: jumpObj.userType,
        username: jumpObj.username,
      };
      let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`;
      return axios.post(src, params).then((rs) => rs);
    },
    getJumpInfo(sys) {
      // 跳转所用参数集合
      let that = this;
      let userId = sessionStorage.getItem("userId");
      let productFlag = sessionStorage.getItem("productFlag"); // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务
      let courseId = userId + "8888";
      let classId = userId + "9999";
      let qstId = "0";
      let identity = "sldx";
      /*
		    encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
		    系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）
		    123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
		    999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
		    2: (单项: 1)、（实训: 2）
		    200: (单项: NONE)、（实训: teamId）
		    001: templateCode
		  */
      let encrypted = `TEACH_${courseId}_${classId}_1_NONE`;
      let obj = {
        token: localStorage.getItem("Authorization"),
        courseId: courseId, // 课程id
        classId: classId, // 班级id
        qstId: qstId, //试题id
        schoolId: sessionStorage.getItem("deptId"), // 机构id
        orgName: sessionStorage.getItem("deptName"), // 机构名称
        username: sessionStorage.getItem("userName"), // 账号
        userId: userId, // 用户id
        nickname: sessionStorage.getItem("loginName"), // 用户姓名
        userType: sessionStorage.getItem("userType"), // 用户类型
        mobile: sessionStorage.getItem("mobile"), // 手机号
        sex: sessionStorage.getItem("sex"), // 性别
        headImgUrl: "", // 头像
        idCard: "", // 身份证
        password: "e10adc3949ba59abbe56e057f20f883e",
        // item: ${questionDto.questionCode},
        item: "27011201-6fe9-46b4-ba7f-fe241aed2132", // questionCode
        identity: identity,
        encrypted: encrypted,
        clientId: "1349883712819109890",
        timestamp: new Date().getTime(),
        roleCodes: "3001",
        templateCode: "zhuan37",
      };
      return obj;
    },
  },
};
</script>
<style lang="scss" scoped>
.intermediate_wrap {
  .taxation_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  .taxation_item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
    li {
      width: 278px;
      height: 180px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      position: relative;
      margin-top: 24px;
      margin-right: 40px;
      .app_logo {
        position: absolute;
        left: 40px;
        top: 48px;
        z-index: 2;
        height: 22px;
      }
      .app_bg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width: 278px;
        height: 180px;
      }
      button {
        position: absolute;
        left: 40px;
        bottom: 24px;
        z-index: 2;
        width: 96px;
        height: 34px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(83, 151, 247, 1);
        border-radius: 4px;
        padding: 0;
        color: #5397f7;
        &:hover {
          background: #5397f7;
          color: #fff;
        }
      }
      .text {
        position: absolute;
        left: 32px;
        top: 45%;
        z-index: 2;
        font-size: 16px;
        color: #004e97;
        font-weight: 600;
      }
    }
  }
  /deep/ .el-dialog__header {
    height: 48px;
    background: #edf4ff;
    padding: 20px 15px 0;
    box-sizing: border-box;
    border-radius: 8px 8px 0 0;
  }
  .cont {
    p {
      font-size: 16px;
      margin-bottom: 10px;
    }
    ul {
      width: 180px;
      margin: 0 auto;
      li {
        font-size: 14px;
        cursor: pointer;
        line-height: 24px;
        text-align: left;
      }
      li.active {
        color: #5397f7;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/intermediate.vue